import { render, staticRenderFns } from "./MyChatDetails.vue?vue&type=template&id=8de1834e&"
import script from "./MyChatDetails.vue?vue&type=script&lang=js&"
export * from "./MyChatDetails.vue?vue&type=script&lang=js&"
import style0 from "./MyChatDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports